import React from 'react';
import { TEAM_MEMBERS } from '@/lib/mockData';

interface AvatarGroupProps {
  memberIds: string[];
  max?: number;
  size?: 'sm' | 'md';
}

export default function AvatarGroup({ memberIds, max = 4, size = 'sm' }: AvatarGroupProps) {
  const shown = memberIds.slice(0, max);
  const rest = memberIds.length - max;
  const sizeClass = size === 'sm' ? 'w-7 h-7 text-xs' : 'w-9 h-9 text-sm';

  return (
    <div className="flex items-center -space-x-2">
      {shown.map((id) => {
        const member = TEAM_MEMBERS.find((m) => m.id === id);
        if (!member) return null;
        return (
          <div
            key={`avatar-${id}`}
            className={`${sizeClass} rounded-full border-2 border-card flex items-center justify-center text-white font-semibold flex-shrink-0`}
            style={{ backgroundColor: member.avatarColor }}
            title={member.name}
          >
            {member.avatarInitials}
          </div>
        );
      })}
      {rest > 0 && (
        <div
          className={`${sizeClass} rounded-full border-2 border-card bg-muted flex items-center justify-center text-muted-foreground font-semibold`}
        >
          +{rest}
        </div>
      )}
    </div>
  );
}